


























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { BPopover, BvEvent } from "bootstrap-vue";
import { formatPhone } from "@/utils";

@Component({
  components: {
    BPopover,
  },
  computed: mapGetters("schedule", ["checkedRows"]),
})
export default class LangPopover extends Vue {
  @Prop(Boolean) readonly show!: boolean;
  id = "update-lang-popover";
  checkedRows!: any[];
  //appts: any[] =[];
  loading = false;
  get target() {
    return this.id + "-target";
  }
  update() {
    this.$modal.show("dialog", {
      title: "Update Appts",
      text: "Do you want to change the language of  "+ this.checkedRows.length +" appointments, Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$modal.hide("dialog");
            this.loading = true;
            try {
              const { checkedRows } = this;
              for (let i = 0; i < checkedRows.length; i++) {
                const appt = checkedRows[i];
                const { id } = appt;
                try {
                  const result: string = await this.$store.dispatch(
                    "schedule/changeLang",{
                      id: appt.id
                    }
                  );
                  appt.sent = true;
                  appt.lang = appt.lang ==="EN"? "ES":"EN";
                 /*  if (result.includes("ERROR SENDING VOICE")) {
                    const error = result.split(":")[1].trim();
                    appt.archiveError = error;
                  } else {
                    appt.archived = true;
                  } */
                } catch (error) {
                  appt.error = error.response.data;
                }
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  close() {
    if (this.loading) return;
    this.$root.$emit("bv::hide::popover", this.id);
    //this.$root.$emit("bv::hide::popover");
    this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
    console.log("ARCHIVE_CLOSE");
  }
  hide(e: BvEvent) {
    if (this.loading) e.preventDefault();
   // this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
    console.log("UPDATE_LANG_HIDDEN");
  }
  get formatPhone() {
    return formatPhone;
  }
  mounted() {

  }
}
